<div [ngClass]="backgroundClass()" fxLayout="column" fxLayoutAlign="center center">
  <div class="title">{{ 'CARD_LOADER.LOADING' | translate }}</div>
  <div class="load-bar">
    <div class="bar"></div>
  </div>
</div>
